import { render, staticRenderFns } from "./ShowRecentOrders.vue?vue&type=template&id=5c793100&"
import script from "./ShowRecentOrders.vue?vue&type=script&lang=js&"
export * from "./ShowRecentOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports